var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 1.09375V22.6562C0.9375 24.4727 2.40234 25.9375 4.21875 25.9375H29.5312C29.7656 25.9375 30 26.1719 30 26.4062C30 26.6992 29.7656 26.875 29.5312 26.875H4.21875C1.875 26.875 0 25 0 22.6562V1.09375C0 0.859375 0.175781 0.625 0.46875 0.625C0.703125 0.625 0.9375 0.859375 0.9375 1.09375ZM20.625 19.375C20.332 19.375 20.1562 19.1992 20.1562 18.9062C20.1562 18.6719 20.332 18.4375 20.625 18.4375H26.4844L16.875 8.82812L11.543 14.1016C11.3672 14.2773 11.0742 14.2773 10.8984 14.1016L5.27344 8.47656C5.09766 8.30078 5.09766 8.00781 5.27344 7.83203C5.44922 7.65625 5.74219 7.65625 5.91797 7.83203L11.25 13.1055L16.5234 7.83203C16.6992 7.65625 16.9922 7.65625 17.168 7.83203L27.1875 17.793V11.875C27.1875 11.6406 27.3633 11.4062 27.6562 11.4062C27.8906 11.4062 28.125 11.6406 28.125 11.875V18.9062C28.125 19.1992 27.8906 19.375 27.6562 19.375H20.625Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoss);
export default __webpack_public_path__ + "static/media/icon_loss.a3462595b54edd4b42cac21d401ad485.svg";
export { ForwardRef as ReactComponent };